function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2227 885",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2020.71,747.265c-0,-93.735 -76.101,-169.835 -169.835,-169.835c-93.734,0 -169.835,76.1 -169.835,169.835l-1135.19,-0c-0,-93.735 -76.101,-169.835 -169.835,-169.835c-93.734,0 -169.835,76.1 -169.835,169.835l-132.361,-0c-19.578,-0 -38.354,-7.778 -52.198,-21.621c-13.844,-13.844 -21.621,-32.62 -21.621,-52.198l0,-303.891c-0,-71.09 40.833,-135.859 104.975,-166.511l349.402,-166.972c49.692,-23.747 104.069,-36.072 159.144,-36.072l529.06,0c47.768,-0 95.083,9.273 139.318,27.303l830.105,338.361c69.473,28.318 114.889,95.874 114.889,170.895l-0,63.068c-0,39.156 -15.555,76.708 -43.242,104.396c-27.688,27.687 -65.24,43.242 -104.396,43.242l-58.542,-0Zm-1129.41,-656.588l-86.003,-0c-80.154,-0 -157.311,30.465 -215.843,85.225l-123.703,115.73c-2.213,2.07 -2.936,5.283 -1.823,8.101c1.113,2.819 3.836,4.671 6.866,4.671l420.506,0l0,-213.727Zm84.121,213.727l668.181,0c3.527,0 6.561,-2.494 7.243,-5.954c0.682,-3.459 -1.178,-6.919 -4.441,-8.257l-412.23,-169.131c-48.902,-20.064 -101.252,-30.385 -154.11,-30.385l-104.643,-0l-0,213.727Zm875.456,305.797c75.647,0 137.063,61.416 137.063,137.064c0,75.647 -61.416,137.063 -137.063,137.063c-75.647,-0 -137.063,-61.416 -137.063,-137.063c-0,-75.648 61.416,-137.064 137.063,-137.064Zm-1474.86,0c75.647,0 137.063,61.416 137.063,137.064c0,75.647 -61.416,137.063 -137.063,137.063c-75.647,-0 -137.063,-61.416 -137.063,-137.063c-0,-75.648 61.416,-137.064 137.063,-137.064Z",
    style: {
      fill: "#141f2a"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarIcon);
export default __webpack_public_path__ + "static/media/CarIcon.b773f1a06e9ae3d6801cbcc8cbcbc6b0.svg";
export { ForwardRef as ReactComponent };